import api from "../../config/client.axios.api";

export const getTotalErrorTransactionApi = async (
  accountId: string,
  startDate: string,
  endDate: string,
  storeCode: string,
  resultId: string
) => {
  const response = await api.get(`/record-transaction/count-error`, {
    params: {
      accountId: accountId && accountId,
      startDate,
      endDate,
      storeCode,
      resultId,
    },
  });
  return response.data;
};
